import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface AGUSelectOption { readonly Key: string; readonly Label: string; }

/**
 * The rail's single-choice control — the mockup's native `.rgroup select`
 * (grants.html:108, jobs.html:218): full width, 13px/600, 1px control border,
 * radius 6, `8px 9px`. A native element on purpose: the mockup's own choice,
 * and the browser paints the option list.
 */
@Component({
    standalone: false,
    selector: 'agu-select',
    templateUrl: './select.component.html',
    styleUrl: './select.component.scss',
})
export class AGUSelectComponent {
    @Input() Options: readonly AGUSelectOption[] = [];
    @Input() Value = '';
    /** Used only when no `Id` pairs the control with a visible `<label for>`. */
    @Input({ required: true }) AriaLabel!: string;
    @Input() Id: string | null = null;
    @Input() Disabled = false;
    @Output() ValueChange = new EventEmitter<string>();

    OnChange(event: Event): void {
        const target = event.target;
        if (target instanceof HTMLSelectElement) this.ValueChange.emit(target.value);
    }
}
